export class User {
    id: number
    avatar_url: string
    email: string
    firstName: string
    lastName: string
    constructor(data: any) {
        this.id = data.id
        this.avatar_url = data.avatar_url
        this.email = data.email
        this.firstName = data.firstName
        this.lastName = data.lastName
    }
 
    static build(data: any): User {
        return new User(data)
    }
}